import AppConfig from '../appConfig';
import AbstractFetch from './AbstractFetch';
// CONST
import { moduleConfig } from '../lib/config/appConstants';

class SiteFetch extends AbstractFetch {
  static getBillingPortalUrl() {
    return AbstractFetch.fetch(AppConfig.apiUrl + '/v1/site/billingportal', {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      return response.json();
    });
  }

  static getSubscriptionInfo() {
    return AbstractFetch.fetch(AppConfig.apiUrl + '/v1/site/subscriptioninfo', {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      return response.json();
    });
  }

  static getExportHistoryInfo(module) {
    let url = AppConfig.apiUrl + '/v1/user/downloads/pac';
    if (module === moduleConfig.EB.shortName) {
      url = AppConfig.apiUrl + '/v1/user/downloads/eb';
    }

    return AbstractFetch.fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      return response.json();
    });
  }
}

export default SiteFetch;
